import useNavigate from '@/hooks/router/useNavigate';
import { Paper, styled, Typography } from '@mui/material';
import { TokenForm, ClientConfigurationContext } from '@ngt/openiddict'
import { FC, useCallback, useContext } from 'react';
import { useParams } from 'react-router-dom';

const StyledPaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(2)
}))

const Token: FC = () => {
    const navigate = useNavigate();

    const { id } = useParams();
    
    const { data: clientConfiguration } = useContext(ClientConfigurationContext);

    const onCancel = useCallback(async () => {
        navigate(clientConfiguration?.administrationUris?.tokens ?? '/');
    }, [navigate, clientConfiguration?.administrationUris?.tokens])

    const afterDelete = useCallback(async () => {
        navigate(clientConfiguration?.administrationUris?.tokens ?? '/', { replace: true });
    }, [navigate, clientConfiguration?.administrationUris?.tokens]);

    const afterSubmit = useCallback(async () => {
        navigate(clientConfiguration?.administrationUris?.tokens ?? '/', { replace: true });
    }, [navigate, clientConfiguration?.administrationUris?.tokens])

    return (
        <>
            <Typography variant="h1" gutterBottom>
                Token
            </Typography>
            <StyledPaper>
                <TokenForm
                    id={id && !isNaN(+id) ? +id : undefined}
                    afterDelete={afterDelete}
                    afterSubmit={afterSubmit}
                    onCancel={onCancel}
                    debug={import.meta.env.DEV}
                />
            </StyledPaper>
        </>
    );
}

export default Token;